<script setup lang="ts">
import BPMModule from "./BPMModule.vue"
import KeyModule from "./KeyModule.vue"
import GenresModule from "./GenresModule.vue"
import EnergyModule from "./EnergyModule.vue"
import MoodsModule from "./MoodsModule.vue"
import InstrumentsModule from "./InstrumentsModule.vue"
import { defineProps, onMounted, reactive, provide } from "vue"
import { graphql } from "~/utils/graphql"

const props = defineProps<{
  trackId: string
  isAdmin: boolean
}>()

const track = reactive({
  bpm: null as number | null,
  key: null as string | null,
  genres: [] as string[],
  energy: null as number | null,
  moods: [] as string[],
  instruments: [] as string[],
  isClassified: false,
})

provide("isAdmin", props.isAdmin)

onMounted(async () => {
  const response = await graphql(
    `
      query TrackQuery($trackId: ID!) {
        track(id: $trackId) {
          ... on Track {
            id
            key
            bpm
            genres
            energy
            moods
            instruments
            isClassified
          }
        }
      }
    `,
    {
      trackId: props.trackId,
    }
  )

  track.bpm = response.data.track.bpm
  track.key = response.data.track.key
  track.genres = response.data.track.genres || []
  track.energy = response.data.track.energy
  track.moods = response.data.track.moods || []
  track.instruments = response.data.track.instruments || []
  track.isClassified = response.data.track.isClassified
})
</script>

<template>
  <div class="js-track-sidebar">
    <div v-if="!track.isClassified" class="mt-3 text-sm text-zinc-500 flex items-center">
      <i class="bi bi-hourglass-split mr-2"></i>
      Analyzing...
    </div>
    <div class="mt-3 flex justify-between space-x-4">
      <BPMModule :track-id="trackId" :current-bpm="track.bpm" />
      <KeyModule :current-key="track.key" :track-id="trackId" />
    </div>
    <div class="mt-3">
      <EnergyModule :track-id="trackId" :current-energy="track.energy" />
    </div>
    <div class="mt-3 space-y-3">
      <GenresModule :track-id="trackId" :current-genres="track.genres" />
      <MoodsModule :track-id="trackId" :current-moods="track.moods" />
      <InstrumentsModule :track-id="trackId" :current-instruments="track.instruments" />
    </div>
  </div>
</template>
